import Vue from 'vue'
import PreviewSvga from "./PreviewSvga.vue";
const PreviewSvgaConstructor = Vue.extend(PreviewSvga)

export const previewSvga = (options) => {
  const instance = new PreviewSvgaConstructor({
    data: {
      ...options,
    }
  })

  document.body.appendChild(instance.$mount().$el)

  instance.$watch('visible', () => {
    if (!instance.visible) {
      setTimeout(() => {
        if (instance.$el && instance.$el.parentNode === document.body) {
          document.body.removeChild(instance.$el)
        }
      }, 300)
    }
  })

  return instance
}
